import { apiConfig } from '../config/api';

const STORAGE_KEY = 'marketplaceOnboarding';

export function getMarketplaceOnboarding() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setMarketplaceOnboarding(value) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
}

export function clearMarketplaceOnboarding() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function hasMarketplaceOnboarding() {
  const onboarding = getMarketplaceOnboarding();
  return !!onboarding?.customerIdentifier || !!onboarding?.sessionId;
}

export async function linkMarketplaceOnboarding(user) {
  const onboarding = getMarketplaceOnboarding();
  if (!onboarding?.customerIdentifier && !onboarding?.sessionId) {
    return { skipped: true };
  }

  const userId = user?.email || user?.username || user?.sub;
  if (!userId) {
    return { skipped: true };
  }

  const body = {
    userId,
    cognitoSub: user?.sub || null,
    email: user?.email || null,
  };

  // Prefer sessionId (new server-side-resolved flow) over customerIdentifier (legacy).
  if (onboarding.sessionId) {
    body.sessionId = onboarding.sessionId;
  } else {
    body.customerIdentifier = onboarding.customerIdentifier;
  }

  const response = await fetch(apiConfig.marketplaceLink, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || data.error || 'Marketplace account linking failed.');
  }

  clearMarketplaceOnboarding();
  return data;
}